<template>
    <div id='quote_fail_modal' class="modal">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Incomplete quotes</p>
                <button class="delete" aria-label="close" @click="closeQuoteModal()"></button>
            </header>
            <section class="modal-card-body">
                <ul style="margin:2em auto; font-weight:bold;" id='quote_fail_list'></ul>
                <div>Please submit the above quotes before continuing.</div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="closeQuoteModal()">
                    Edit
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuoteFailModal",
    methods: {
        closeQuoteModal() {
            this.$emit('doClose')
        },
    }
};
</script>